import React, { Fragment, useContext } from 'react';
import { styled } from '@mui/material/styles';
import { Divider, Tab, Tabs } from '@mui/material';
import { AppContext } from '@/AppContext';
import palette from '@/theme/eventos/palette';

const PREFIX = 'SAInnerMenu';

const classes = {
  divider: `${PREFIX}-divider`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.divider}`]: {
    borderBottom: `1px solid ${palette.secondary.main}`,
  },
}));

const SAInnerMenu = props => {
  const appContext = useContext(AppContext);

  const valueFromUrl = () => {
    const path = appContext.history.location.pathname;
    if (path.indexOf('account') !== -1) {
      return 'account';
    }
    if (path.indexOf('total-stat') !== -1) {
      return 'total-stat';
    }
    if (path.indexOf('tariff') !== -1) {
      return 'tariff';
    }
    if (path.indexOf('payment') !== -1) {
      return 'payment';
    }
    return '';
  };

  return (
    <Root>
      <Tabs
        className={classes.tabs}
        onChange={() => {}}
        scrollButtons='auto'
        value={valueFromUrl()}
        variant='scrollable'
      >
        <Tab
          label={'Аккаунты'}
          value={'account'}
          onClick={() => {
            appContext.history.push('/sa/account');
          }}
        />
        <Tab
          label={'Тарифы'}
          value={'tariff'}
          onClick={() => {
            appContext.history.push('/sa/tariff');
          }}
        />
        <Tab
          label={'Платежи'}
          value={'payment'}
          onClick={() => {
            appContext.history.push('/sa/payment');
          }}
        />
        <Tab
          label={'Статистика'}
          value={'total-stat'}
          // onClick={() => {appContext.history.push("/sa/total-stat")}}
        />
      </Tabs>
      <Divider className={classes.divider} />
    </Root>
  );
};

export default SAInnerMenu;
